/**
 * The greenbook app icon (public/icon.svg) — an open book with the profit line climbing out,
 * the "green book that always wins". Used wherever the placeholder "g" tile used to sit.
 * The SVG carries its own rounded dark tile, so it drops in at any size.
 */
export function AppIcon({ size = 24, className = "" }: { size?: number; className?: string }) {
  return (
    <img
      src="/icon.svg"
      width={size}
      height={size}
      alt="greenbook"
      draggable={false}
      className={`shrink-0 select-none ${className}`}
    />
  );
}
